module.exports = {"name":"subscribeToWatchOrFollow","audiences":["allMembers"],"experimentAllocation":0.3,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"watch","weight":1},{"name":"follow","weight":1}],"autotrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/subscribeToWatchOrFollow.json
// module id = tORg
// module chunks = 0